<template>
    <div id="app" class="shop">
        <div class="header">
            <p class="selected-category">{{ translations.title }}</p>
            <span>{{ translations.description }}</span>
        </div>
        <div class="cart">
            <div class="cart-header">
                <span class="name">{{ translations.table_cart.name }}</span>
                <span>{{ translations.table_cart.quantity }}</span>
                <span>{{ translations.table_cart.days }}</span>
                <span>{{ translations.table_cart.sum_net }}</span>
                <span>{{ translations.table_cart.sum_gross }}</span>
            </div>
            <div class="cart-item" v-for="item in cartStore.items" :key="item.id">
                <div class="cart-item-actions">
                    <button @click="cartStore.removeFromCart(item.id)">X</button>
                </div>
                <div class="cart-item-image">
                    <router-link :to="'/rent/product/' + item.id" class="cart-item-image">
                        <img :src="imageUrl + encodeURIComponent(item.meta.images[0])"
                            alt="product image" />
                    </router-link>
                </div>
                <div class="cart-item-details">
                    <router-link :to="'/rent/product/' + item.id" style="display: contents" class="cart-item-image">
                        <p class="name_p">{{ item.name }}</p>
                    </router-link>
                    <!-- <p>{{ item.quantity }}</p>
                    <p>{{ item.days }}</p> -->
                    <input type="number" v-model.number="item.quantity" 
                        :step="item.category === 'glass' ? (item.meta.quantity || item.meta.szt || 1) : 1" 
                        :min="item.category === 'glass' ? (item.meta.quantity || item.meta.szt || 1) : 1"
                        @keydown="(item.category === 'glass' && (item.meta.quantity || item.meta.szt) > 1) ? $event.preventDefault() : null" class="quantity-input" />
                    <input type="number" v-model.number="item.days" min="1" class="days-input" />
                    <p class="price">{{ totalNet(item.rental_price, item.quantity, item.days) }} {{
                        translations.currency }}</p>
                    <p class="price">{{ totalBrutto(item.rental_price, item.quantity, item.days) }} {{
                        translations.currency }}</p>
                </div>

            </div>
            <div class="summary">
                <div class="add-info">
                    <textarea id="message" v-model="cartStore.add_information.message"
                        :placeholder=translations.add_information rows="5"></textarea>
                </div>
                <div class="cart-summary">

                    <div class="col">
                        <div class="label">
                            <p>{{ translations.sum }}</p>
                        </div>
                        <div class="values">
                            <p class="price">{{ cartStore.totalNet }} {{ translations.currency }}</p>
                            <p class="price">{{ cartStore.totalBrutto }} {{ translations.currency }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <button @click="shareCart" class="share-button" @mouseover="showInfo = true"
                            @mouseleave="showInfo = false" @mousemove="moveTooltip($event)">
                            <i class="pi pi-share-alt" style="font-size: 1rem"></i>
                        </button>
                        <div v-if="showInfo" class="tooltip"
                            :style="{ top: tooltipPosition.top + 'px', left: tooltipPosition.left + 'px' }">
                            Kliknij, aby udostępnić swój koszyk
                        </div>
                        <button @click="sendAdditionalInfo">{{ translations.button }}</button>
                    </div>
                </div>
            </div>

        </div>
        <div class="cart-mobile">
            <div class="cart-item" v-for="item in cartStore.items" :key="item.id">
                <div class="row_1">
                    <div class="cart-item-actions">
                        <button @click="cartStore.removeFromCart(item.id)">X</button>
                    </div>
                    <div class="cart-item-image">
                        <router-link :to="'/rent/product/' + item.id" class="cart-item-image">
                            <img :src="imageUrl + encodeURIComponent(item.meta.images[0])"
                                alt="product image" />
                        </router-link>
                    </div>
                    <p class="name_p">{{ item.name }}</p>
                </div>
                <div class="details">
                    <div class="row_1">
                        <span>{{ translations.table_cart.quantity }}</span>
                        <div class="stepper-group">
                            <button type="button" class="stepper__btn" aria-label="Zmniejsz"
                                @click="dec(item, 'quantity')">-</button>
                            <input type="number" v-model.number="item.quantity" 
                                :step="item.category === 'glass' ? (item.meta.quantity || item.meta.szt || 1) : 1" 
                                :min="item.category === 'glass' ? (item.meta.quantity || item.meta.szt || 1) : 1"
                                @keydown="(item.category === 'glass' && (item.meta.quantity || item.meta.szt) > 1) ? $event.preventDefault() : null" class="quantity-input" />
                            <button type="button" class="stepper__btn" aria-label="Zwiększ"
                                @click="inc(item, 'quantity')">+</button>
                        </div>
                    </div>
                    <div class="row_1">
                        <span>{{ translations.table_cart.days }}</span>
                        <div class="stepper-group">
                            <button type="button" class="stepper__btn" aria-label="Zmniejsz"
                                @click="dec(item, 'days')">-</button>
                            <input type="number" v-model.number="item.days" min="1" class="days-input" />
                            <button type="button" class="stepper__btn" aria-label="Zwiększ"
                                @click="inc(item, 'days')">+</button>
                        </div>
                    </div>
                    <div class="row_1">
                        <span>{{ translations.table_cart.sum_net }}</span>
                        <p>{{ totalNet(item.rental_price, item.quantity, item.days) }} {{ translations.currency }}</p>
                    </div>
                    <div class="row_1">
                        <span>{{ translations.table_cart.sum_gross }}</span>
                        <p>{{ totalBrutto(item.rental_price, item.quantity, item.days) }} {{ translations.currency }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="summary">
                <div class="add-info">
                    <textarea id="message" v-model="cartStore.add_information.message"
                        :placeholder=translations.add_information rows="5"></textarea>
                </div>
                <div class="cart-summary">

                    <div class="col">
                        <div class="label">
                            <p>{{ translations.sum }}</p>
                        </div>
                        <div class="values">
                            <p class="price">{{ cartStore.totalNet }} {{ translations.currency }}</p>
                            <p class="price">{{ cartStore.totalBrutto }} {{ translations.currency }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <button @click="shareCart" class="share-button">
                            <i class="pi pi-share-alt" style="font-size: 1rem"></i>
                        </button>
                        <button @click="sendAdditionalInfo">{{ translations.button }}</button>
                    </div>
                </div>
            </div>
        </div>
        <CartNotification v-if="showNotification" message="Link skopiowano do schowka" />
        <AppFooter />
    </div>
</template>

<script>
import translationsData from '@/assets/text_lang/translations.json';
import { useLanguageStore } from '@/theme';
import { computed } from 'vue';
import { useCartStore } from '../../store/cart';
import CartNotification from '@/components/CartNotification.vue';

import 'primeicons/primeicons.css'
import AppFooter from './FootBar.vue';
import { useHead } from '@vueuse/head';




export default {
    components: {
        AppFooter,
        CartNotification
    },
    data() {
        return {
            additionalInfo: '', // Przechowywanie wartości textarea
            showInfo: false,
            showNotification: false,
            tooltipPosition: { top: 0, left: 0 },
        };
    },
    setup() {
        const languageStore = useLanguageStore();
        const cartStore = useCartStore();
        const translations = computed(() => {
            return translationsData[languageStore.currentLanguage]["cart"];
        });
        // cartStore.clearCart();
        useHead({
            title: 'Koszyk',
            meta: [
                {
                    name: 'description',
                    content: 'Sprawdź zawartość koszyka i przygotuj zapytanie o wynajem sprzętu barowego. Cocktail Service obsługuje wydarzenia w Warszawie i całej Polsce.'
                },
                {
                    property: 'og:title',
                    content: 'Koszyk | Cocktail Service'
                },
                {
                    property: 'og:description',
                    content: 'Zweryfikuj produkty, terminy i przejdź do podsumowania zapytania o wynajem sprzętu.'
                },
                {
                    property: 'og:image',
                    content: 'https://www.cocktailservice.pl/img/O-NAS-1.webp'
                },
                {
                    property: 'og:url',
                    content: 'https://www.cocktailservice.pl/cart'
                }
            ]
        });
        return {
            translations,
            cartStore,
            imageUrl: process.env.VUE_APP_IMAGE_URL
        };
    },
    computed: {
        translatedQuantity() {
            return this.quantity === 1 ? this.translations.pc : this.translations.pcs;
        },
    },
    methods: {
        shareCart() {
            const cartItems = this.cartStore.items.map(item => {
                return `${item.id}:${item.quantity}:${item.days}`;
            }).join(',');
            const url = `https://www.cocktailservice.pl/cart?items=${cartItems}`;
            this.showNotification = true;
            navigator.clipboard.writeText(url)
                .then(() => {
                })
                .catch(err => {
                    console.error('Błąd podczas kopiowania do schowka: ', err);
                });
            setTimeout(() => {
                this.showNotification = false;
            }, 3000)
        },
        inc(item, type) {
            if (type === 'quantity') {
                const stepVal = item.category === 'glass' ? Number(item.meta.quantity || item.meta.szt || 1) : 1;
                item.quantity = Number(item.quantity) + stepVal;
            } else if (type === 'days') {
                item.days = Number(item.days) + 1;
            }
        },
        dec(item, type) {
            if (type === 'quantity') {
                const stepVal = item.category === 'glass' ? Number(item.meta.quantity || item.meta.szt || 1) : 1;
                const minVal = stepVal;
                const current = Number(item.quantity);
                if (current - stepVal >= minVal) {
                    item.quantity = current - stepVal;
                }
            } else if (type === 'days') {
                const current = Number(item.days);
                if (current > 1) {
                    item.days = current - 1;
                }
            }
        },
        moveTooltip(event) {
            // const tooltip = this.$refs.tooltip;
            const offsetX = 3; // Optional, adjust the tooltip position relative to the cursor
            const offsetY = 3; // Optional, adjust the tooltip position relative to the cursor
            this.tooltipPosition = {
                top: event.clientY + offsetY,
                left: event.clientX + offsetX,
            };
        },
        totalNet(price, quantity, days) {
            return price * quantity * days;
        },
        totalBrutto(price, quantity, days) {
            const net = this.totalNet(price, quantity, days) * 1.23;
            return net.toFixed(2); // Dodanie 23% do ceny netto
        },
        sendAdditionalInfo() {
            if (this.cartStore.items.length > 0) {
                this.$router.push('/cart/summary');
            }

        },
        async fetchProductDetails(productId) {
            try {
                const apiUrl = process.env.VUE_APP_API_URL;
                const response = await fetch(`${apiUrl}/products/${productId}`);
                const data = await response.json();
                
                if (data.products && Array.isArray(data.products)) {
                    return data.products[0];
                } else if (data.product) {
                    return data.product;
                }
                return data;
            } catch (error) {
                console.error(`Błąd podczas pobierania szczegółów produktu o ID ${productId}:`, error);
                return null; // Zwraca null w przypadku błędu
            }
        },
        async importCart() {

            const query = new URLSearchParams(window.location.search);
            const itemsParam = query.get('items');
            if (itemsParam) {
                this.cartStore.clearCart();
                const cartItems = itemsParam.split(',').map(item => {
                    const [id, quantity, days] = item.split(':');
                    return { id, quantity: parseInt(quantity, 10), days };
                });
                const productsData = await Promise.all(
                    cartItems.map(item => this.fetchProductDetails(item.id))
                );

                productsData.forEach((productData, idx) => {
                    if (productData) {
                        const item = cartItems[idx];
                        const productToAdd = {
                            ...productData,
                            id: item.id,
                            quantity: item.quantity,
                            days: item.days,
                            totalPrice: productData.rental_price * item.quantity * 1
                        };
                        this.cartStore.addToCart(productToAdd);
                    }
                });

                console.log('Produkty zostały dodane do koszyka:', this.cartStore.items);
            }
        }

    },
    mounted() {
        // Automatyczny import koszyka po załadowaniu strony
        this.importCart();
    }
};
</script>
<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body,
html {
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
}

#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    /* Wymusza, aby kontener miał minimalną wysokość równą wysokości okna przeglądarki */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    transform: scale(1.25);
}

.shop {
    flex: 1;
    /* Umożliwia rozciągnięcie zawartości w pionie */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* Rozdziela główną zawartość od stopki */
    align-items: center;
    padding-top: 290px;
    background-color: var(--dark-color-font);
    color: var(--dark-color-background);
    width: 100%;
    height: 100%;
    padding-left: 30px;
    padding-right: 30px;

}

.shop .header {
    width: 90%;
    /* Ustawienie szerokości na 100% */
    max-width: 1100px;
    text-align: left;
    /* Wyrównanie tekstu do lewej */
    /* Dodanie marginesu poniżej nagłówka, jeśli potrzebne */
}

.share-icon {
    width: 40px;
    height: 20px;
    background-color: transparent !important;
    /* Wymuszenie przezroczystego tła */
    object-fit: contain;
    /* Dopasowanie obrazu do kontenera */
    display: inline-block;
    /* Upewnij się, że ikona zachowuje się jak element inline */
}

.shop .header .selected-category {
    color: var(--dark-color-background);
    margin: 0;
    /* Ustawienie marginesu na 0, aby wyrównać tekst do lewej */
    margin-bottom: 40px;
}

.shop .header span {
    font-size: 12pt;
    color: var(--dark-color-background);
}

.shop .header .warning {
    padding-top: 20px;
    font-size: 12pt;
    color: var(--dark-color-red);

}


.cart {
    font-size: 12pt;
    width: 90%;
    max-width: 1100px;
    margin-top: 40px;
}

.cart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 2px solid var(--dark-color-background);
    font-weight: bold;
}

.summary .cart-summary .col .share-button,
.col .share-button {
    width: 50%;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: var(--dark-color-background);
    border: 1px solid var(--dark-color-background);
    padding: 10px 20px;
    margin-top: 20px;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 2px;
}



.summary .cart-summary .col .share-button:hover,
col .share-button:hover {
    background: var(--dark-border-color);
    color: var(--dark-color-background);
    border: 1px solid var(--dark-color-background);
}

.tooltip {
    position: absolute;
    background: var(--dark-color-background);
    color: var(--dark-color-font);
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid var(--dark-color-font);
    font-size: 12pt;
    white-space: nowrap;
    pointer-events: none;
    /* Zapobiega interakcji z tooltipem */
    z-index: 1000;
    /* Ustawienie na najwyższy poziom */
    transition: left 0.1s ease, top 0.1s ease;
    /* Płynne przesuwanie */
}

.cart-header,
.cart-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
}

.cart-header .name {
    width: 43%;
    /* Szerokość 33% dla kolumny "Produkt" */
    text-align: center;
    /* Wyrównanie tekstu do lewej */
}

.cart-header span:not(.name) {
    flex: 1;
    /* Równa szerokość dla pozostałych nagłówków */
    text-align: center;
    /* Wyśrodkowanie tekstu */
}

.cart-item {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 2px solid var(--dark-color-background);
}

.cart-item-image {
    margin-right: 20px;
    /* Dodaj większy odstęp po prawej stronie obrazu */
}


.cart-item-image img {
    width: 50px;
    height: 50px;
    object-fit: contain;
}


.cart-item-details {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding-left: 20px;
    /* Dodaj dodatkowy odstęp od lewej */
}


.cart-item-details .cart-item-image .name_p {
    text-align: left;
    /* Wyrównanie do lewej */
    width: 33%;
    /* Wymuszenie szerokości */
    color: var(--dark-color-background);
    border: 2px solid transparent;
    border-radius: 2px;
    padding: 12px;
    margin-right: 2px
}

.cart-item-details .cart-item-image .name_p:hover {
    border: 2px solid var(--dark-color-background);
    border-radius: 2px;
}



.cart-item-details input,
.cart-item-details p:not(.name_p) {
    border-left: 1px solid var(--dark-color-background);
    padding: 0 10px;
    flex: 1;
    /* Równa szerokość dla pozostałych nagłówków */
    text-align: center;

}

.cart-item-details input,
.cart-item-details .price {
    font-size: 12pt;
    color: var(--dark-color-red);
    width: 10%;
    border: none;
}




.cart-item-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
}

.cart-item-actions button {
    background: none;
    border: none;
    color: var(--dark-color-red);
    border: 1px solid transparent;
    font-size: 14px;
    cursor: pointer;
    padding: 10px;
    margin-left: 5px;
}

.cart-item-actions button:hover {
    background: none;
    border: none;
    color: var(--dark-color-red);
    border: 1px solid var(--dark-color-red);
    background: rgba(200, 200, 200, 0.2);
    /* Delikatnie szare, półprzezroczyste tło */
    font-size: 14px;
    cursor: pointer;
    padding: 10px;
}


.summary {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
    padding: 10px 0;
    border-top: 1px solid var(--dark-color-background);
}

.add-info {
    flex: 1;
    padding: 10px;
    text-align: left;
}

.add-info textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid var(--dark-color-background);
    background: var(--dark-color-font);
    color: var(--dark-color-background);
    display: flex;
    text-align: left;
    align-items: center;
    /* Wyrównanie pionowe */
    justify-content: center;
    /* Wyrównanie poziome */
    border-radius: 2px;
}


.cart-summary {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    width: 40%;
    padding: 10px 0;
    padding-left: 10px;
    font-weight: bold;

}

.cart-summary .col {
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 10px;
    padding-bottom: 20px;
    border-bottom: 2px solid var(--dark-color-background);
}

.cart-summary .col .label {
    flex: 0 0 20%;
    /* 20% szerokości dla etykiety */
    text-align: left;
    padding-left: 10px;
}

.cart-summary .col .values {
    flex: 0 0 80%;
    /* 80% szerokości dla wartości */
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.cart-summary .col .values .price {
    flex: 1;
    color: var(--dark-color-red);
    text-align: center;
    padding: 0 10px;
    border-left: 1px solid var(--dark-color-background);
}

.cart-summary button {
    width: 100%;
    height: 60%;
    background: var(--dark-color-background);
    color: var(--dark-color-font);
    border: 1px solid transparent;
    padding: 10px 20px;
    margin-top: 20px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 2px;
}

.cart-summary button:hover {
    background: var(--dark-color-font);
    color: var(--dark-color-background);
    border: 1px solid var(--dark-color-background);
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 2px;
}

@media (min-width: 801px) {
    .cart-mobile {
        visibility: hidden;
        display: none;
    }
}

@media (max-width: 800px) {
    .shop {
        padding-top: 120px;

    }

    .stepper-group {
        flex: 0 0 auto;
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
    }

    .stepper__btn {
        width: 32px;
        height: 32px;
        font-size: 18px;
        background: transparent;
        /* czarne tło */
        color: var(--dark-color-background);
        /* biały tekst */
        border: none;
        /* bez ramki */
        margin: 0 5px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .stepper__btn:hover {
        background: rgba(200, 200, 200, 0.2);
        ;
        /* lekko szare tło przy najechaniu */
        color: var(--dark-color-background);
        /* czarny symbol */
    }

    .stepper__btn:active {
        background: rgba(200, 200, 200, 0.2);
        ;
        color: var(--dark-color-background);
    }

    .cart {
        visibility: hidden;
        display: none;
    }

    .cart-mobile {
        margin-top: 30px;
        width: 90%;
        border-top: 2px solid var(--dark-color-background);
        border-bottom: 2px solid var(--dark-color-background);
        margin-bottom: 30px;
    }

    .row_1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid var(--dark-color-background);
        width: 100%;
    }

    .row_1 input {
        width: 20%;
        height: 20px;
        font-size: 10px;
        padding: 0px;
        text-align: center;
        border: none;
        margin: 0px;
    }

    .cart-item {
        font-size: 10px;
        font-weight: normal;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: none;
    }

    .cart-item-image img {
        width: 40px;
        height: 40px;
        object-fit: contain;
    }

    .details {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .summary {
        display: flex;
        flex-direction: column;
        /* Układ pionowy */
        align-items: stretch;
        /* Dopasowanie szerokości do rodzica */
        width: 100%;
        /* Ustawienie na pełną szerokość ekranu */
        padding: 10px 0;
        border-top: 1px solid var(--dark-color-background);
    }

    .summary .add-info {
        width: 100%;
        /* Cała szerokość ekranu */
        text-align: center;
        margin-bottom: 20px;
        padding: 0px;
    }

    .summary .add-info textarea {
        width: 100%;
        /* Dopasowanie do kontenera */
        font-size: 12px;
        border-radius: 2px;
    }

    .summary .cart-summary {
        width: 100%;
        /* Cała szerokość ekranu */
        display: flex;
        flex-direction: column;
        /* Układ pionowy */
        gap: 10px;
        /* Odstęp między elementami */
        text-align: center;
        /* Wyśrodkowanie tekstu */
    }

    .summary .cart-summary .col {
        width: 100%;
        /* Pełna szerokość */
        display: flex;
        font-size: 12px;

        justify-content: space-between;
        /* Rozkład wartości */
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid var(--dark-color-background);
    }

    .summary .cart-summary .col .label {
        flex: 1;
        text-align: left;
        /* Wyrównanie tekstu do lewej */
    }

    .summary .cart-summary .col .values {
        flex: 1;
        text-align: right;
        /* Wyrównanie wartości do prawej */
        font-weight: bold;
    }

    .summary .cart-summary .col button {
        width: 100%;
        /* Cała szerokość */
        padding: 15px;
        font-size: 14px;
        background: var(--dark-color-background);
        color: var(--dark-color-font);
        border: 1px solid none;
        border-radius: 4px;
        cursor: pointer;
        text-transform: uppercase;
    }

    .summary .cart-summary .col button:hover {
        background: var(--dark-color-font);
        color: var(--dark-color-background);
        border: 1px solid var(--dark-color-background);
        padding: 15px;
        cursor: pointer;
        font-size: 14px;
        border-radius: 2px;
    }

    .summary .cart-summary .col .share-button,
    .col .share-button {
        padding: 15px;
    }
}
</style>